<div [@submit]="submitState" (@submit.done)="endState()" class="lot-box-inner" style="position: relative">
  <app-loader [showLoader]="loader" [inlineLoader]="true"> </app-loader>

  <div class="top-image-wrap">
    <img *ngIf="eachLotData?.thumbnailImages.length == 0" class="lot-banner" alt="lot-banner"
      src="/assets/images/image_not_found.svg" role="button" (click)="
        goToViewLotDetailsFromWatchList(
          eachLotData?.auction.auctionCode,
          eachLotData?.lotNumber
        )
      " />
    <img *ngIf="eachLotData?.thumbnailImages.length > 0" class="lot-banner" alt="lot-banner"
      [src]="eachLotData?.thumbnailImages[0]?.name" role="button" (click)="
        goToViewLotDetailsFromWatchList(
          eachLotData?.auction.auctionCode,
          eachLotData?.lotNumber
        )
      " />
    <span class="lot-no cursor custom-lot-number" [ngClass]="{ featuredLot: eachLotData?.isFeatured }" role="button"
      (click)="
        goToViewLotDetailsFromWatchList(
          eachLotData?.auction.auctionCode,
          eachLotData?.lotNumber
        )
      ">
      {{ (eachLotData?.isFeatured ? "Featured" : "") + " Lot" }}
      <span>#{{ eachLotData?.lotNumber }}</span>
    </span>

    <ng-container *ngIf="!readOnlyCatalog">
      <ng-container *ngIf="!showListView && !isItWatchList && !isLotClosed">
        <span class="starred" *ngIf="eachLotData?.loggedInUser && !isAddedToWatchlist">
          <img alt="star-stroke" src="/assets/images/star-stroke-grey.svg" role="button"
            (click)="addToWatchList(eachLotData?.id, eachLotData?.lotNumber)" />
        </span>
        <span class="starred" *ngIf="eachLotData?.loggedInUser && isAddedToWatchlist">
          <img alt="star-filled" src="/assets/images/star-filled.svg" role="button" (click)="
              removeFromWatchList(eachLotData?.id, eachLotData?.lotNumber)
            " />
        </span>

      </ng-container>
    </ng-container>

  </div>

  <div class="details-wrap">
    <ng-container *ngIf="!readOnlyCatalog">
      <div *ngIf="
          !eachLotData?.isBiddingPaused &&
          showTimer &&
          eachLotData?.loggedInUser &&
          eachLotData?.loggedInUser?.isApproved &&
          eachLotData?.auction.auctionStatus == auctionStatuses.live
        ">
        <div class="bid-closes bidCloses">
          <img alt="clock-icon" class="mr-2" src="./assets/images/clock.svg" />
          <strong class="mr-1">Closes In </strong>
          <timer-countdown [isLowConnectionMode]="isLowConnectionMode" [timeLeft]="eachLotData?.timeLeft"
            [startTime]="eachLotData?.lotStartTimeUtc" [endTime]="eachLotData?.lotEndTimeUtc"
            (timeReached)="isTimeReached($event)">
          </timer-countdown>

          <span class="extended badge-dark card-badge ml-3" *ngIf="eachLotData?.extendedByMinutes">Extended</span>
        </div>
      </div>
    </ng-container>

    <p class="des">{{ eachLotData?.description | characterLimit: 140 }}
      <ng-container *ngIf="eachLotData?.description &&
      eachLotData?.description?.length > 140">
        <div class="d-inline for-icons">
          <a role="button" (click)="goToViewLotDetailsFromWatchList(
            eachLotData?.auction.auctionCode,
            eachLotData?.lotNumber
          )" class="edit-bids-icon" style="color: #8d1231; text-decoration:underline">
            <span class="m-0 p-0">more info</span>
          </a>
        </div>
      </ng-container>
    </p>

    <p class="des cursor-pointer" *ngIf="isItWatchList || isItActiveBidList" role="button"
      (click)="goToAuctionTitle(eachLotData?.auction?.auctionCode)">
      {{ eachLotData?.auction?.title }}
    </p>
    <p class="auc-address mb-2" *ngIf="
        eachLotData?.auction?.auctionStatus == auctionStatuses.upcoming &&
        isItWatchList
      ">
      <span class="">Opens
        {{
        eachLotData?.auction?.startDateTime
        | toLocalDateTime
        : false
        : eachLotData?.auction?.timeZoneCode
        : "EEEE
        MMMM d,h:mm a"
        }}
      </span>
    </p>

    <div class="location-wrap">
      <div class="location">
        <ng-container *ngIf="eachLotData?.quantity > 1">
          <span class="ml-0 mr-2 forQty">Qty: {{ eachLotData?.quantity }}</span>
        </ng-container>
        <img class="location" alt="location" height="13" src="/assets/images/location-grey.svg" />
        <span>{{ eachLotData?.location }}</span>
      </div>

      <ng-container *ngIf="!readOnlyCatalog">
        <ng-container *ngIf="eachLotData?.auction?.auctionStatus == auctionStatuses.live">
          <p class="bid">{{ eachLotData?.bidCount }} Bids</p>
        </ng-container>
        <div class="des" style="font-size: 12px" *ngIf="
            showTimer &&
            eachLotData?.loggedInUser &&
            eachLotData?.auction.auctionStatus == auctionStatuses.live
          ">
          <!-- for reserve price -->
          <ng-container *ngIf="eachLotData?.reservePrice">
            <ng-container *ngIf="eachLotData?.bidCount > 0; else elseTemplate">
              <ng-container *ngIf="
                  eachLotData?.currentBid >= eachLotData?.reservePrice;
                  else elseBody
                ">
                <p class="mb-1">Reserve Price Met</p>
              </ng-container>
              <ng-template #elseBody>
                <p class="mb-1">Reserve Price Not Met</p>
              </ng-template>
            </ng-container>
            <ng-template #elseTemplate>
              <p class="mb-1">Subject To Reserve Price</p>
            </ng-template>
          </ng-container>
          <!-- for bulk lot or individual lot i text -->
          <ng-container *ngIf="
              eachLotData?.lotType === lotType.individual &&
              eachLotData?.addedInBulkLotName
            ">
            <p class="m-0">
              Subject to Bulk Lot of {{ eachLotData?.addedInBulkLotName }}
              <span class="custom-tooltip" #tooltip="matTooltip" matTooltip="This lot is subject to Bulk Lot {{
                  eachLotData?.addedInBulkLotName
                }}. In order for this lot to be awarded, the aggregate total of Lots {{
                  eachLotData?.associatedLots | bulkLots
                }} must exceed the value of {{
                  eachLotData?.addedInBulkLotName
                }}. Additionally, the Bulk Bidder/Individual Bidders will be given {{
                  eachLotData?.individualModifier
                }}% protection." [matTooltipPosition]="'above'">
                <img alt="info" src="../assets/images/info.svg" />
              </span>
            </p>
          </ng-container>
          <ng-container *ngIf="
              eachLotData?.lotType === lotType.bulk && eachLotData?.lots?.length
            ">
            <p class="m-0">
              Subject to Lots {{ eachLotData?.lots | bulkLots }}
              <span class="custom-tooltip" #tooltip="matTooltip"
                matTooltip="
                  The Bulk Bid is Subject to the Aggregate of Lots {{
                  eachLotData?.lots | bulkLots
                }}. The Bulk Bidder/Piecemeal Bidders will be given {{
                  eachLotData?.modifier
                }}% protection. Whichever lot(s) produce the highest total will be awarded the Lot. The Bulk Bid will close before the individual lots and you will not get a chance to re-bid after the individual lots close."
                [matTooltipPosition]="'above'">
                <img alt="info" src="../assets/images/info.svg" />
              </span>
            </p>
          </ng-container>
          <ng-container *ngIf="!isLotClosed">
            <ng-container *ngIf="
                eachLotData?.willSell &&
                eachLotData?.lotType != eachLotData?.willSell &&
                eachLotData?.addedInBulkLotName
              ">
              <p class="m-0">Below Bulk Bid Threshold</p>
            </ng-container>
            <ng-container *ngIf="
                eachLotData?.willSell &&
                eachLotData?.lotType != eachLotData?.willSell &&
                eachLotData?.lots?.length
              ">
              <p class="m-0">Below Bulk Bid Threshold</p>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>

  <ng-container *ngIf="!readOnlyCatalog">
    <div class="status-pos" *ngIf="eachLotData?.auction?.auctionStatus == 2 && isItWatchList">
      <p class="for-approval awaiting m-0" *ngIf="!eachLotData?.auction?.isApproved">
        <img alt="approval-icon" class="approval-icon" src="./assets/images/awaiting-approval.svg" />
        <span>Awaiting Approval</span>
      </p>
      <p class="for-approval approved m-0" *ngIf="eachLotData?.auction?.isApproved">
        <img alt="approval-icon" class="approval-icon" src="./assets/images/approved.svg" />
        <span>Approved!</span>
      </p>
    </div>
  </ng-container>

  <ng-container *ngIf="!readOnlyCatalog">
    <div class="bid-wrap">
      <ng-content *ngIf="isItWatchList"></ng-content>

      <ng-container *ngIf="
          !eachLotData?.isBiddingPaused &&
          loggedInUser > 0 &&
          eachLotData?.loggedInUser?.isApproved &&
          eachLotData?.auction.auctionStatus == auctionStatuses.live &&
          !isLotClosed
        ">
        <div class="top-price" *ngIf="loggedInUser">
          <div class="bid-price left-price">
            <p class="name">{{eachLotData?.bidCount == 0 ? 'Opening Bid' : 'Current Bid'}} Amount</p>
            <p class="amount">
              {{
              eachLotData?.currentBid
              | auctionCurrency: eachLotData?.auction?.curreny
              }}
            </p>
          </div>

          <div class="bid-price right-price">
            <p class="name">
              {{ isUserHighestBidder ? "Max Bid Amount" : "Next Required Bid" }}
            </p>
            <p class="amount">
              <ng-container *ngIf="isUserHighestBidder; else nextRequiredBidSection">
                {{
                eachLotData?.highestBid
                | auctionCurrency: eachLotData?.auction?.curreny
                }}
              </ng-container>
              <ng-template #nextRequiredBidSection>
                {{
                eachLotData?.nextRequiredBid
                | auctionCurrency: eachLotData?.auction?.curreny
                }}
                <small>
                  {{ eachLotData?.quantity > 1 ? "Each" : "" }}
                </small>
              </ng-template>
            </p>
          </div>
        </div>
        <div class="bid-price-input" *ngIf="loggedInUser">
          <div class="price-left">
            <div class="form-group no-float-fields m-0 height-42">
              <mat-form-field appearance="outline">
                <input matInput type="number" [formControl]="biddingAmount" [min]="minBid" [max]="maxBid" />
              </mat-form-field>
              <control-messages [control]="biddingAmount"></control-messages>
            </div>
          </div>

          <div class="price-right">
            <button type="button" class="btn btn-white-border w-100" role="button" (click)="onSubmit(false)" [title]="
                !isLowConnectionMode
                  ? 'You are on real time updates'
                  : 'You are on low connection mode'
              ">
              Bid Now
            </button>
          </div>
        </div>

        <div class="bid-submit" *ngIf="loggedInUser && !isUserHighestBidder">
          <button type="button" class="btn btn-colored w-100" role="button" (click)="onSubmit(true)" [title]="
              !isLowConnectionMode
                ? 'You are on real time updates'
                : 'You are on low connection mode'
            ">
            Quick Bid
            {{
            eachLotData?.nextRequiredBid
            | auctionCurrency: eachLotData?.auction?.curreny
            }}
          </button>
        </div>

        <div class="bid-green-hover-outer" *ngIf="loggedInUser && isUserHighestBidder">
          <button type="button" class="btn btn-colored btn-green-hover w-100">
            <img alt="white-check" class="mr-2" src="./assets/images/white-check.svg" />
            High Bidder
          </button>
          <div class="hover-wrap">
            <p class="m-0">
              You will be able to "Quick Bid" after your bid is outbid.
              <br />
              <br />
              You may still increase your max bid by entering a higher value on
              clicking Bid Now.
            </p>
          </div>
        </div>
        <div *ngIf="errorMsg != null">
          <p class="error-text">{{ errorMsg }}</p>
        </div>
      </ng-container>

      <div class="pause-bidding text-center" [ngClass]="{ 'my-3': showListView }" *ngIf="eachLotData?.isBiddingPaused">
        <img alt="clock-icon" class="clock-icon" style="height: 25px" src="./assets/images/clock-grey.svg" />
        <h5>Bidding is paused!</h5>
      </div>

      <div>
        <ng-container *ngIf="showTimer">
          <button type="button" class="btn btn-white-border w-100 mt-2" [ngClass]="{ 'mb-2': !showListView }" *ngIf="
              eachLotData?.auction.isRegistrationActive &&
              (eachLotData?.auction.auctionStatus == auctionStatuses.live ||
                eachLotData?.auction.auctionStatus ==
                  auctionStatuses.upcoming) &&
              eachLotData?.loggedInUser == null
            " role="button" (click)="goToRegister(eachLotData?.auction.auctionCode)">
            Register to Bid
          </button>
        </ng-container>

        <div class="w-100 mb-2 sold-wrap text-center" *ngIf="
            eachLotData?.lotStatus && isLotClosed && eachLotData?.loggedInUser
          ">
          <ng-container [ngSwitch]="eachLotData?.lotStatus">
            <ng-container *ngSwitchCase="soldStatuses.sold">
              <div class="badge-type">
                <span class="card-badge-colored mr-2">SOLD</span>
              </div>
              <p *ngIf="eachLotData?.soldTo == loggedInUser">Winning Bidder</p>
              <p *ngIf="findLooser() > -1 && eachLotData?.soldTo !== loggedInUser">Unsuccessful</p>
              <p *ngIf="isItActiveBidList">
                {{
                eachLotData?.loggedInUserLastBid
                | auctionCurrency: eachLotData?.auction?.curreny
                }}
              </p>
            </ng-container>
            <ng-container *ngSwitchCase="soldStatuses.unsold">
              <div class="badge-type">
                <span class="card-badge-colored mr-2"> UNSOLD </span>
                <div *ngIf="isItWatchList">
                  <a role="button" class="btn btn-colored w-100 mt-2" [routerLink]="[
                      '/',
                      eachLotData?.auction.auctionCode,
                      'enquire'
                    ]">Inquire Now</a>
                </div>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="soldStatuses.cancelled">
              <div class="badge-type">
                <span class="card-badge-colored mr-2"> CANCELLED </span>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="soldStatuses.pending">
              <div class="badge-type">
                <span class="card-badge-colored mr-2"> PENDING </span>
              </div>
            </ng-container>
          </ng-container>
        </div>

        <ng-container *ngIf="loggedInUser > 0 && eachLotData?.loggedInUser?.isApproved">
          <div class="refreshWatchlist">
            <div class="mb-2 mt-2 sold-wrap d-flex align-items-center list-view"
              *ngIf="showListView && !isItWatchList && !isLotClosed">
              <div class="starred add-wishlist" role="button" (click)="
                  addToWatchList(eachLotData?.id, eachLotData?.lotNumber)
                " *ngIf="loggedInUser != 0 && !isAddedToWatchlist">
                <span class="for-image">
                  <img alt="star-stroke" src="/assets/images/star-stroke-grey.svg" />
                </span>
                <span class="ml-2">Add To Watchlist</span>
              </div>


              <a [routerLink]="['/profile/my-watchlist']" *ngIf="loggedInUser != 0 && isAddedToWatchlist">
                <div class="add-wishlist">
                  <span class="for-image">
                    <img alt="star-filled" src="/assets/images/star-filled.svg" />
                  </span>
                  <span class="ml-2">Go to Watchlist</span>
                </div>
              </a>

            </div>
            <span class="outbid-text ml-2 mt-3" *ngIf="eachLotData?.outbid && !isLotClosed">Outbid</span>

            <ng-container *ngIf="isLowConnectionMode && !isLotClosed">
              <a class="iconRefresh" role="button" role="button" (click)="getLotDataInApi()">
                <img alt="refresh" title="refresh" class="mr-2" src="/assets/images/refresh.svg" />
                Refresh
              </a>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>



<ng-template #quickBidModal>
  <div class="modal-header pl-3">
    <h4 class="modal-title pull-left">Review Bids</h4>
    <button type="button" class="close pull-right circle-icon" aria-label="Close" role="button"
      (click)="closeReviewModal()">
      <img alt="cross" _ngcontent-lrm-c188="" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body">
    <div class="column-list">
      <div class="parts">
        <div class="left-wrap">Auction</div>
        <div class="right-wrap">{{ eachLotData.auction.title | titlecase }}</div>
      </div>

      <div class="parts">
        <div class="left-wrap">Bidder</div>
        <div class="right-wrap">
          Paddle No. {{ eachLotData.loggedInUser.paddleNumber }} {{userFullName | titlecase}}
        </div>
      </div>
    </div>

    <div class="data-table-wrap w-100">
      <table aria-label="table" class="w-100 table-with-border review-bids-table">
        <tbody>
          <tr class="mat-row">
            <td class="mat-cell column-1 listing-data-entry table-with-row-header">
              <span class="td-header">Lot #</span>
              {{ eachLotData.lotNumber }}
            </td>
            <td class="mat-cell column-2 listing-data-entry table-with-row-header yellow-bg">
              <span class="td-header">Lot Description</span>
              {{ eachLotData.description | characterLimit: 50 }}
            </td>
            <td class="mat-cell column-3 listing-data-entry table-with-row-header">
              <span class="td-header">Quick Bid</span>
              {{ eachLotData.nextRequiredBid | auctionCurrency: eachLotData.auction.curreny }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-container *ngIf="changeInAmount">
      <p>Note : New Bid has been placed. Please bid again.</p>
    </ng-container>

    <div class="review-btns-wrap mt-3">
      <ng-container *ngIf="!changeInAmount">
        <button type="button" class="btn btn-colored" role="button" (click)="submitBidByApi(true)">
          Submit Bid
        </button>
      </ng-container>
      <button type="button" class="btn btn-white-border" role="button" (click)="closeReviewModal()">
        Cancel
      </button>
    </div>
  </div>
</ng-template>
